export type BaseMediaReference = {
    id?: string;
    mediaType: MediaType;
    url: string;
    isHeldForReview?: boolean;
}

export type ImageReference = BaseMediaReference & {
    mediaType: MediaType.Image;
    blurhash?: string;
}

export type VideoReference = BaseMediaReference & {
    mediaType: MediaType.Video;
    thumbnailUrl: string;
    thumbnailBlurhash?: string;
}

export enum MediaType {
    Image = "IMAGE",
    Video = "VIDEO"
}

export type MediaReference = ImageReference | VideoReference;
